import pako from 'pako';

export const decompressGzippedData = <T>(data: string): T => {
  const binaryString = atob(data); // Decode base64 to binary string
  const binaryArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i += 1) {
    binaryArray[i] = binaryString.charCodeAt(i); // Convert to Uint8Array
  }
  const decompressed = pako.ungzip(binaryArray, { to: 'string' });
  return JSON.parse(decompressed);
};
